var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-tab-empty-wrapper"},[_c('div',{staticClass:"search-tab-empty-content"},[_c('div',{staticClass:"search-tab-empty-img"}),_vm._v("\n    "+_vm._s(_vm.$t('no-results'))+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }